module.exports = __webpack_public_path__ + "static/media/annuities.b36e8897.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/annuities.svg
// module id = 3073
// module chunks = 0